import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useStore } from "../store";
import { LoginForm, loginSchema } from "../schemas/loginSchema";
import { AuthUser } from "../models/User";
import { auth } from "../services/authServices";
import { useApiProvider } from "../providers/api/apiProvider";
import { useMemo, useState } from "react";
import { IFieldShowValue } from "../types/show";

export const useLoginController = () => {
  const {
    login,
  } = useStore();

  const {
    simpleApiCall,
  } = useApiProvider();

  const form = useForm<LoginForm>({
    resolver: yupResolver( loginSchema ),
    defaultValues: {
      email: '',
      password: '',
    },
    mode: 'all',
  });

    const [ fieldShowValue, setFieldShowValue ] = useState<Omit<IFieldShowValue, "confirmPassword">>({
      password: false,
    });

    const toggleFieldShowValue = ( field: keyof Omit<IFieldShowValue, "confirmPassword"> ) => {
      setFieldShowValue(( value ) => {
        value[ field ] = !value[ field ];

        return { ...value };
      });
    };

  const onSubmit = async ( data: LoginForm ) => {
    const user = await simpleApiCall<LoginForm, AuthUser>( auth, data );

    if( user !== null ) login( user );
  };

  const handleSubmit = form.handleSubmit( onSubmit );

  return useMemo(() => ({
    form,
    fieldShowValue,
    handleSubmit,
    toggleFieldShowValue,
    // eslint-disable-next-line
  }), [
    form,
    fieldShowValue,
  ]);
};
